import React from 'react';
import PropTypes from 'prop-types';
import TreeView from '@Containers/TreeView';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

const spinnerId = 'datapoints-spinner';

function DatapointsExportModalContent({ isLoading, getDatapoints, changeDatapoints, selectedDatapoints }) {
  return (
    <div className="exportModal__content">
      {isLoading && <SimpleSpinner id={spinnerId} />}
      <TreeView
        taxonomyType="export"
        taxonomiesGetter={getDatapoints}
        selectedItems={selectedDatapoints.ids}
        onChange={changeDatapoints}
        selectedCustomItems={[]}
        showCountIndicator={false}
      />
    </div>
  );
}

DatapointsExportModalContent.propTypes = {
  isLoading: PropTypes.bool,
  selectedDatapoints: PropTypes.object,
  getDatapoints: PropTypes.func.isRequired,
  changeDatapoints: PropTypes.func.isRequired,
};

export default DatapointsExportModalContent;
